var render, staticRenderFns
import script from "./BRow.vue?vue&type=script&lang=js&"
export * from "./BRow.vue?vue&type=script&lang=js&"
import style0 from "./BRow.vue?vue&type=style&index=0&id=729c7e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c7e18",
  null
  
)

export default component.exports